import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';

const PrivateRoute = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [redirectPath, setRedirectPath] = useState(null);
  const isAuthenticated = authService.isAuthenticated();

  useEffect(() => {
    const checkOnboardingStatus = async () => {
      if (!isAuthenticated) {
        setRedirectPath('/login');
        setLoading(false);
        return;
      }

      try {
        const user = authService.getCurrentUser();

        // Allow access to onboarding and payment pages
        const onboardingPaths = ['/pricing-plans', '/payment-details', '/onboarding/organization', '/onboarding/personal', '/onboarding/preferences'];
        if (onboardingPaths.includes(location.pathname)) {
          setRedirectPath(null);
          setLoading(false);
          return;
        }

        // Skip onboarding checks for now - allow direct access to dashboard
        // TODO: Re-enable onboarding flow later
        /*
        // Check if user has completed onboarding
        if (!user.hasCompletedPayment) {
          setRedirectPath('/pricing-plans');
        } else if (!user.hasCompletedOnboarding) {
          // Redirect to the appropriate onboarding step
          const step = user.onboardingStep || 2;
          if (step === 2) {
            setRedirectPath('/onboarding/organization');
          } else if (step === 3) {
            setRedirectPath('/onboarding/personal');
          } else if (step === 4) {
            setRedirectPath('/onboarding/preferences');
          }
        } else {
          setRedirectPath(null); // Allow access to dashboard
        }
        */
        setRedirectPath(null); // Allow access to dashboard
      } catch (error) {
        console.error('Error checking onboarding status:', error);
        // Allow access to dashboard even if there's an error
        setRedirectPath(null);
      } finally {
        setLoading(false);
      }
    };

    checkOnboardingStatus();
  }, [isAuthenticated, location.pathname]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
